export const CommunityItems = [
    {
      title: 'STUDENT GOV',
      path: '/studentgov',
      cName: 'dropdown-link'
    },
    {
      title: 'J-TEAM',
      path: '/jteam',
      cName: 'dropdown-link'
    },
    {
      title: 'ASSOCIATES/\nALUMNI',
      path: '/associates-alumni',
      cName: 'dropdown-link'
    }
  ];
  
  export const FormItems = 
  [
    {
      title: 'ACCESSIBILITY FUND',
      external: 'https://docs.google.com/forms/d/e/1FAIpQLSdt3hB8SsNMdGu8_R0nuFMLIyeqW2UMTlhAIw-vhh-s4Ynw3w/viewform',
      cName: 'dropdown-link'
    },
    {
      title: 'JIBA FUND',
      external: 'https://docs.google.com/forms/d/e/1FAIpQLSdfdOFz7ugG-UBQs-l3VUd3Ekg0dBd9UuWG_T_LNBJFkSKI5Q/viewform?c=0&w=1',
      cName: 'dropdown-link'
    },
    {
      title: 'RHA HELP FORM',
      external: 'https://forms.gle/F9pTKgNc4fCNZsDr7',
      cName: 'dropdown-link'
    },
    {
      title: 'RICE MUTUAL AID',
      external: 'https://linktr.ee/ricemutualaid',
      cName: 'dropdown-link'
    },
    {
      title: 'P-CARD REQUEST',
      external: 'https://forms.gle/yRUphKyi7PkHovhr5',
      cName: 'dropdown-link'
    },
    {
      title: 'P-CARD POST USE',
      external: 'https://forms.gle/nLmh3VVJSEAie2w8A',
      cName: 'dropdown-link'
    },
    {
      title: 'RICE RESOURCES',
      external: 'https://docs.google.com/spreadsheets/d/16Xjca-Rjk1V1WAggpVee0vRPY0ui9W8QUkr_ftR0kjg/edit?usp=sharing',
      cName: 'dropdown-link'
    },
  ];